import { component } from 'picoapp'
import { zelektor, loopify, toggleDisplay, toggleFixRoot } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { closeBtn, listWrapper: listWrappers, mobileMenuInner, item: items, currentIcon } = zelektor(node)
    let gender
    if (localStorage.getItem('spreeglee_gender') === 'men' || localStorage.getItem('spreeglee_gender') === 'women') {
        gender = localStorage.getItem('spreeglee_gender')
    } else {
        gender = 'men'
    }


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('menu:toggle', () => {
        toggleMenu()
    })

    node.addEventListener('click', e => {
        if (e.target === node) toggleMenu()
    })

    closeBtn.addEventListener('click', toggleMenu)

    ctx.on('gender:setTemp', ({ gender }) => setGender(gender))

    ctx.on('gender:set', ({gender}) => setGender(gender))

    loopify(items).forEach(item => {
        const { submenuBtn: submenuBtns, submenu: submenus, backBtn: backBtns } = zelektor(item)

        if (loopify(submenuBtns).length && loopify(submenus).length && loopify(backBtns).length) {
            loopify(submenuBtns).forEach(btn => {
                btn.addEventListener('click', e => {
                    const { index } = e.currentTarget.dataset
                    const submenu = loopify(submenus).find(sm => sm.dataset.index === index)
                    submenu.classList.add('is-open')
                    mobileMenuInner.scrollTo(0,0)
                })
            })

            loopify(backBtns).forEach(btn => {
                btn.addEventListener('click', e => {
                    const { index } = e.currentTarget.dataset
                    const submenu = loopify(submenus).find(sm => sm.dataset.index === index)
                    submenu.classList.remove('is-open')
                })
            })
        }
    })


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    initGender()


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function toggleMenu() {
        toggleFixRoot()
        node.classList.toggle('is-open')
    }

    function initGender() {
        ctx.emit('gender:setTemp', state => {
            return {
                gender:  gender
            }
        })
    }

    function setGender(gender) {
        node.classList.remove('gender--women')
        node.classList.remove('gender--men')

        node.classList.add(`gender--${gender}`)

        loopify(listWrappers).forEach(wrapper => wrapper.classList.remove('is-active'))

        const matchingWrapper = loopify(listWrappers).find(w => w.classList.contains(`js-${gender}`))
        matchingWrapper.classList.add('is-active')
    }
})